import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-return-to-work',
  templateUrl: './return-to-work.component.html',
  styleUrls: ['./return-to-work.component.css']
})
export class ReturnToWorkComponent implements OnInit {

  questions: SurveyQuestionVm[];
  constructor(private surveyServiceProxy: SurveyService,) { }
  showWelcomeText: boolean = true; 
  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    this.questions = await this.surveyServiceProxy.getEmployeeReturnToWorkQuestions().toPromise();
    console.log(this.questions);
  }
  hideWelcomeText() {
    this.showWelcomeText = false;
  }
}
